<template>
    <list-page-shell title="已清税">
        <order-workbench
            :show-title="false"
            :show-create-button="false"
            :extra-query-params="{ tax_cleared: 1, tax_cleared_from_administrator: 1 }"
            :list-table-variant="'tax_cleared'"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'TaxClearedList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/TaxClearedList.vue